import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { OldSolutionsSection } from './components/OldSolutionsSection';
import { MechanismSection } from './components/MechanismSection';
import { ProductSection } from './components/ProductSection';
import { AudienceSection } from './components/AudienceSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-wine selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <OldSolutionsSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <ProductSection data-id="element-5" />
      <AudienceSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}